import { Paragraph10 } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent, ReactNode } from 'react';

import styles from './property-status.module.css';

interface PropertyStatusProps {
  children: ReactNode;
  variant: 'required' | 'alpha' | 'beta' | 'deprecated';
}

/**
 */
const PropertyStatus: FunctionComponent<PropertyStatusProps> = ({
  children,
  variant,
}) => {
  return (
    <Paragraph10
      weight={'medium'}
      className={clsx(styles.status, styles[variant])}
    >
      {children}
    </Paragraph10>
  );
};

export { PropertyStatus };
